import { render, staticRenderFns } from "./mafiaways.vue?vue&type=template&id=b5a04718"
import script from "./mafiaways.vue?vue&type=script&lang=js"
export * from "./mafiaways.vue?vue&type=script&lang=js"
import style0 from "./mafiaways.vue?vue&type=style&index=0&id=b5a04718&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports